import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { emailMasking } from "../../../util/CommonReadonlyMasking";
import { ApplicationState } from "../../../store";
import * as MyAccountActions from "../../../store/myAccount/actions";
import { useForm, Controller } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import * as services from "../../../store/service";
import PhoneInput, { isValidPhoneNumber, formatPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useTranslation } from "react-i18next";

const Preferences = (props: any) => {
    const initial: any = {};
    const dispatch = useDispatch();
    const [visibleEmail, setVisisbleEmail]: any = useState([]);
    const getAccountInformation = (forceReload?: boolean) => dispatch(MyAccountActions.actionCreators.getAccountInformation(forceReload));
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );
    const _contactPreference = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._contactPreference
                : null
            : null
    );
    const GetIsIdfUser = () => dispatch(MyAccountActions.actionCreators.GetIsIdfUser());
    const isIDFFlagLoading = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUserLoading ? state.myAccountServiceState.isIdfUserLoading : false
    );
    const isIDFUser = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUser ? state.myAccountServiceState.isIdfUser : false
    );
    const [contactPreference, setContactPreference] = useState(initial);
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isInvalidAlertSelection, setIsInvalidAlertSelection] = useState(false);
    const partnerConfig = useSelector((state: ApplicationState) =>
        state.configurationState ? (state.configurationState.configuration ? state.configurationState.configuration.partnerConfig : null) : null
    );
    const businessInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._businessInformation
                : null
            : null
    );
    const isBitdefender = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2569
                ? true
                : false
            : false
    );
    const isAdtPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2610
                ? true
                : false
            : false
    );

    const ssoOption = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions) ||
            null
    );
    const { t: tLang } = useTranslation();

    /**Validation with react-hook-form ***/
    const { errors, formState, handleSubmit, control, watch } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const showEditForm = () => {
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setShowEdit(false);
    };

    useEffect(() => {
        GetIsIdfUser();
    }, []);

    const save = (form: any) => {
        if (contactPreference != null && accountInfo != null && personalAccountInformation) {
            setIsLoading(true);
            services.GetAccountInformation().then((accountInfoResponse) => {
                const requestBody = {
                    FirstName: personalAccountInformation.firstName,
                    LastName: personalAccountInformation.lastName,
                    MiddleName: personalAccountInformation.middleInitial,
                    Email: accountInfo.email,
                    Phone: accountInfo.phone ? (getCountryInfo() ? accountInfo.phone.replace(/[^0-9+]/g, "") : accountInfo.phone) : accountInfo.phone,
                    PersonalSMS: form.smsNumber ? (getCountryInfo() ? form.smsNumber.replace(/[^0-9+]/g, "") : form.smsNumber) : form.smsNumber,
                    Address1: accountInfo.address1,
                    Address2: accountInfo.address2,
                    City: accountInfo.city,
                    State: accountInfo.state,
                    Country: accountInfo.country,
                    ZipCode: accountInfo.zipCode,
                    IsEmailIdentityNotificationOptOut: contactPreference.idCrimeAndBreachNews,
                    IsEmailNotificationOptOut: contactPreference.alertNotification,
                    IsPushNotificationOptOut: contactPreference.appPushNotification,
                    IsSmsNotificationOptOut: contactPreference.textSMSNotification,
                    IsTextMessagePreferenceUpdated: true,
                    BusinessName: businessInformation && businessInformation.businessName ? businessInformation.businessName : "",
                    EIN: accountInfoResponse._unifiedAccountInfo._businessInformation.ein,
                    FAX: businessInformation && businessInformation.fax ? businessInformation.fax : "",
                };
                httpClient
                    .sendRequest("POST", "api/accountInfo/saveContactInformation", requestBody)
                    .then((data) => {
                        setIsLoading(false);
                        if (data.isSuccess) {
                            Notification({
                                type: "success",
                                title: tLang("manageAccount.myAccount.preferences.notification.successTitle"),
                                message: tLang("manageAccount.myAccount.preferences.notification.successMsg"),
                            });
                            getAccountInformation(true);
                            setShowEdit(false);
                        }
                    })
                    .catch(function (error) {
                        setIsLoading(false);
                        Notification({
                            type: "error",
                            title: "Error",
                            message: error,
                            duration: 0,
                        });
                    });
            });
        }
    };

    const checkBoxChangeHandler = (event: any) => {
        const el = event.currentTarget;
        setContactPreference({ ...contactPreference, [el.name as string]: el.checked === true ? true : false });
    };

    useEffect(() => {
        if (
            contactPreference &&
            contactPreference.textSMSNotification === false &&
            contactPreference.appPushNotification === false &&
            contactPreference.alertNotification === false
        ) {
            setIsInvalidAlertSelection(true);
        } else {
            setIsInvalidAlertSelection(false);
        }
    }, [contactPreference]);

    useEffect(() => {
        setContactPreference(_contactPreference);
    }, [_contactPreference]);

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    const toggleEmailVisibility = (item: any) => {
        if (visibleEmail.length > 0) {
            const index = visibleEmail.findIndex((element: any) => element.email === item.email);
            if (index >= 0) {
                visibleEmail.splice(index, 1);
                setVisisbleEmail([...visibleEmail]);
            } else {
                setVisisbleEmail([...visibleEmail, item]);
            }
        } else {
            setVisisbleEmail([...visibleEmail, item]);
        }
    };

    const getPhoneFieldErrorStatus = () => {
        if (!!errors["smsNumber"] && contactPreference && contactPreference.textSMSNotification && errors["smsNumber"].type === "required") return true;

        if (!!errors["smsNumber"] && contactPreference && errors["smsNumber"].type === "pattern") return true;
        if (!!errors["smsNumber"] && contactPreference && errors["smsNumber"].type === "minLength") return true;
        if (!!errors["smsNumber"] && contactPreference && errors["smsNumber"].type === "maxLength") return true;
        return false;
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch { }
        }
    }, [showEdit]);

    const ssoEmailPreference =
        accountInfo && accountInfo.isSSOUser && ssoOption
            ? ssoOption.disableEmailOnMyAccountScreen
                ? ssoOption.displayEmailUnderMyAccountPreference
                : !ssoOption.disableEmailOnMyAccountScreen && ssoOption.displayEmailUnderMyAccountPreference
            : false;

    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="sliders-h" />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.preferences.title")}</h2>
                        </div>
                    </div>
                    <div className="box-description">
                        <p>{tLang("manageAccount.myAccount.preferences.description")}</p>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="preferences" onClick={showEditForm}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.preferences.editButtonText")}
                                    <span className="sr-only">{tLang("manageAccount.myAccount.preferences.title")}</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                <div className={isLoading || isIDFFlagLoading ? "box-content loading" : "box-content"}>
                    {/* Grid Content */}
                    {!showEdit && contactPreference && (
                        <div role="grid" className="data-grid " id="preferences-grid" aria-hidden="false">
                            {accountInfo && accountInfo.isSSOUser === false ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-preferences-email">
                                            {tLang("manageAccount.myAccount.preferences.label.email")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-preferences-email">
										    {contactPreference.email
                                            ? emailMasking(contactPreference.email)
											: ''}
                                        </div>
                                    </div>
                                </div>
                            ) : ssoEmailPreference ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-preferences-email">
                                            {tLang("manageAccount.myAccount.preferences.label.email")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-preferences-email">
                                            {contactPreference.email
                                            ? emailMasking(contactPreference.email)
											: ''}
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-preferences-text-sms">
                                        {tLang("manageAccount.myAccount.preferences.label.textOrSMS")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-preferences-text-sms">
                                        {contactPreference && contactPreference.smsNumber
                                            ? isValidPhoneNumber(contactPreference.smsNumber)
                                                ? formatPhoneNumber(contactPreference.smsNumber)
                                                : contactPreference.smsNumber
                                            : "-"}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-preferences-alert-notifications">
                                        {tLang("manageAccount.myAccount.preferences.label.alertNotifications")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-preferences-alert-notifications">
                                        {contactPreference.alertNotification === true
                                            ? tLang("manageAccount.myAccount.preferences.label.onAlertNotifications")
                                            : tLang("manageAccount.myAccount.preferences.label.offAlertNotifications")}
                                    </div>
                                </div>
                            </div>

                            {!isIDFUser && !isBitdefender && !isAdtPartner && (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-preferences-id-crime-breach-news">
                                            {tLang("manageAccount.myAccount.preferences.label.crimeBreachNews")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-preferences-id-crime-breach-news">
                                            {contactPreference.idCrimeAndBreachNews === true
                                                ? tLang("manageAccount.myAccount.preferences.label.onAlertNotifications")
                                                : tLang("manageAccount.myAccount.preferences.label.offAlertNotifications")}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {/* Form Content */}
                    {showEdit && contactPreference && (
                        <div id="preferences-form">
                            <form id="preferences-form-container" onSubmit={handleSubmit(save)}>
                                {accountInfo && accountInfo.isSSOUser === false && (
                                    <div role="grid" className="data-grid">
                                        <div role="row" className="form-row inline row">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="data-label-preferences" id="label-edit-preferences-primary-email">
                                                    {tLang("manageAccount.myAccount.preferences.label.primaryEmail")}
                                                </div>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                                <div
                                                    role="gridcell"
                                                    className="data-value-preferences"
                                                    aria-labelledby="label-edit-preferences-primary-email"
                                                    hidden={
                                                        !(
                                                            contactPreference.email === "" ||
                                                            visibleEmail.findIndex((element: any) => element.email === contactPreference.email) >= 0
                                                        )
                                                    }
                                                >
                                                    {contactPreference.email}
                                                </div>
                                                <div role="gridcell" className="data-value" aria-labelledby="label-edit-preferences-primary-email">
                                                    <span
                                                        hidden={
                                                            contactPreference.email === "" ||
                                                            visibleEmail.findIndex((element: any) => element.email === contactPreference.email) >= 0
                                                        }
                                                    >
                                                        <p style={{ wordWrap: "break-word", maxWidth: "70vw" }}>
														 {contactPreference.email ? emailMasking(contactPreference.email): '' }</p>
                                                    </span>
                                                    <div className="form-input-button">
                                                        {contactPreference.email !== "" && (
                                                            <button
                                                                type="button"
                                                                className="btn-default btn-icon-only btn-no-padding"
                                                                onClick={() => {
                                                                    toggleEmailVisibility(contactPreference);
                                                                }}
                                                                title={
                                                                    visibleEmail.findIndex((element: any) => element.email === contactPreference.email) < 0
                                                                        ? tLang("identityVault.monitoredInformation.businessInfoWidget.showEmailToolTip")
                                                                        : tLang("identityVault.monitoredInformation.businessInfoWidget.hideEmailToolTip")
                                                                }
                                                            >
                                                                <span className="btn-icon">
                                                                    <em
                                                                        className={`las ${visibleEmail.findIndex((element: any) => element.email === contactPreference.email) < 0
                                                                                ? "la-eye"
                                                                                : "la-eye-slash"
                                                                            }`}
                                                                    ></em>
                                                                </span>
                                                                <span className="btn-text">Show / Hide Email Text</span>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="form-row inline">
                                    <div
                                        className={`form-row row ${getPhoneFieldErrorStatus() && "status-error"} ${getPhoneFieldErrorStatus() && watch("smsNumber") && !parsePhoneNumber(watch("smsNumber")) ? "country-error" : ""
                                            }`}
                                    >
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label">
                                                    <label htmlFor="my-account-phone-number-preferences">
                                                        {tLang("manageAccount.myAccount.preferences.label.mobileTextAlerts")}
                                                    </label>
                                                </legend>
                                            </div>

                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div role="alert" className="form-row no-margin">
                                                    <div className="form-input">
                                                        <Controller
                                                            name={`smsNumber`}
                                                            control={control}
                                                            defaultValue={contactPreference.smsNumber ? contactPreference.smsNumber : ""}
                                                            className="inputbox"
                                                            rules={{
                                                                required: contactPreference && contactPreference.textSMSNotification ? true : false,
                                                                validate: (value) => {
                                                                    let isValid = false;
                                                                    if (contactPreference && contactPreference.textSMSNotification === true) {
                                                                        isValid = isValidPhoneNo(
                                                                            accountInfo && accountInfo.country ? accountInfo.country : "US",
                                                                            value ? value : ""
                                                                        );
                                                                    } else {
                                                                        if (value) {
                                                                            isValid = isValidPhoneNo(
                                                                                accountInfo && accountInfo.country ? accountInfo.country : "US",
                                                                                value
                                                                            );
                                                                        } else {
                                                                            isValid = true;
                                                                        }
                                                                    }
                                                                    return isValid;
                                                                },
                                                            }}
                                                            render={({ onChange, value }) => (
                                                                <PhoneInput
                                                                    value={value}
                                                                    onChange={onChange}
                                                                    international={false}
                                                                    addInternationalOption={false}
                                                                    defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                    countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                    id="my-account-phone-number-preferences"
                                                                    placeholder={tLang("manageAccount.myAccount.preferences.placeholder.primaryPhone")}
                                                                    maxLength={15}
                                                                />
                                                            )}
                                                        />
                                                        {!!errors["smsNumber"] &&
                                                            contactPreference &&
                                                            contactPreference.textSMSNotification &&
                                                            errors["smsNumber"].type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.required")}
                                                                </span>
                                                            )}
                                                        {!!errors["smsNumber"] && contactPreference && errors["smsNumber"].type === "validate" && (
                                                            <span className="form-error">
                                                                {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.invalid")}
                                                            </span>
                                                        )}
                                                        {!!errors["smsNumber"] &&
                                                            contactPreference &&
                                                            errors["smsNumber"].type === "minLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.phoneNumberMinimum1")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.phoneNumberInvalid")}
                                                                </span>
                                                            ))}
                                                        {!!errors["smsNumber"] &&
                                                            contactPreference &&
                                                            errors["smsNumber"].type === "maxLength" &&
                                                            (getCountryInfo() ? (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.phoneNumberMinimum2")}
                                                                </span>
                                                            ) : (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.preferences.validation.primaryPhone.phoneNumberInvalid")}
                                                                </span>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-container scroll">
                                    <table className="m-table-generic">
                                        <caption className="sr-only">{tLang("manageAccount.myAccount.preferences.label.changePreference")}</caption>
                                        <tbody>
                                            <tr>
                                                <th scope="row" className="table-label">
                                                    &nbsp;
                                                </th>
                                                <td className="text-align-center">
                                                    <strong>{tLang("manageAccount.myAccount.preferences.label.textOrSMS")}</strong>
                                                </td>
                                                <td className="text-align-center">
                                                    {!isIDFUser && partnerConfig && partnerConfig.allowAppDownLoad === true && (
                                                        <strong>{tLang("manageAccount.myAccount.preferences.label.appNotifications")}</strong>
                                                    )}
                                                </td>
                                                <td className="text-align-center">
                                                    <strong>{tLang("manageAccount.myAccount.preferences.label.email")}</strong>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" className="table-label">
                                                    {tLang("manageAccount.myAccount.preferences.label.alertsNReports")}
                                                </th>
                                                <td className="text-align-center">
                                                    <label className="form-checkbox-label checkbox-table" htmlFor="alerts-text-sms">
                                                        <input
                                                            type="checkbox"
                                                            id="alerts-text-sms"
                                                            name="textSMSNotification"
                                                            checked={contactPreference.textSMSNotification}
                                                            onChange={(e) => checkBoxChangeHandler(e)}
                                                        />
                                                        <span className="form-checkbox-label-text">
                                                            <span className="sr-only">
                                                                {tLang("manageAccount.myAccount.preferences.label.textOrSMS4AlertsNReports")}
                                                            </span>
                                                        </span>
                                                    </label>
                                                </td>
                                                <td className="text-align-center">
                                                    {!isIDFUser && partnerConfig && partnerConfig.allowAppDownLoad === true && (
                                                        <label className="form-checkbox-label checkbox-table" htmlFor="alerts-app-notifications">
                                                            <input
                                                                type="checkbox"
                                                                id="alerts-app-notifications"
                                                                name="appPushNotification"
                                                                checked={contactPreference.appPushNotification}
                                                                onChange={(e) => checkBoxChangeHandler(e)}
                                                            />
                                                            <span className="form-checkbox-label-text">
                                                                <span className="sr-only">
                                                                    {tLang("manageAccount.myAccount.preferences.label.appNotifications4AlertsNReports")}
                                                                </span>
                                                            </span>
                                                        </label>
                                                    )}
                                                </td>
                                                <td className="text-align-center">
                                                    <label
                                                        className="form-checkbox-label checkbox-table"
                                                        htmlFor="alerts-email"
                                                        title="Email alerts can not be unchecked"
                                                    >
                                                        <em className="las la-check"></em>
                                                    </label>
                                                </td>
                                            </tr>
                                            {!isIDFUser && !isBitdefender && !isAdtPartner && (
                                                <tr>
                                                    <th scope="row" className="table-label">
                                                        <span>{tLang("manageAccount.myAccount.preferences.label.crimeBreachNews")}</span>
                                                        <br />
                                                    </th>
                                                    <td className="text-align-center">&nbsp;</td>
                                                    <td className="text-align-center">&nbsp;</td>
                                                    <td className="text-align-center">
                                                        <label className="form-checkbox-label checkbox-table" htmlFor="id-crime-and-breach">
                                                            <input
                                                                type="checkbox"
                                                                id="id-crime-and-breach"
                                                                name="idCrimeAndBreachNews"
                                                                onChange={(e) => checkBoxChangeHandler(e)}
                                                                checked={contactPreference.idCrimeAndBreachNews}
                                                            />
                                                            <span className="form-checkbox-label-text">
                                                                <span className="sr-only">
                                                                    {tLang("manageAccount.myAccount.preferences.label.email4CrimeNBreach")}
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="margin-vertical-l"></div>
                                <div className="box-description">
                                    <p>{tLang("manageAccount.myAccount.preferences.infoMsg")}</p>
                                </div>

                                <div className="margin-vertical-l"></div>

                                {isInvalidAlertSelection && <span className="form-error">{tLang("manageAccount.myAccount.preferences.atleastOnePreference")}</span>}
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                    onClick={() => hideEditForm()}
                                                >
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.preferences.cancelButtonText")}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button
                                                    type="submit"
                                                    className="btn-default btn-primary btn-min-width"
                                                    disabled={isSubmitting || isInvalidAlertSelection}
                                                >
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.preferences.saveButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Preferences;
